// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCollapsibleSection-LabelInner_cls1__6XR0d","cls2":"VeloCollapsibleSection-LabelInner_cls2__WqYMM VeloCollapsibleSection-LabelInner_cls1__6XR0d"};